import { get, post, put, patch, del } from '../http/http';
// 设备管理
export default {
    getList: (val) => get('/api', val), // 查询列表
    getPublish: (val) => get('/api/published', val), // 查询已发布列表
    addList: (val) => post('/api', val), // 添加
    getInfo: (val) => get(`/api/${val}`), // 获取详情
    putList: (id, val) => put(`/api/${id}`, val), // 编辑
    delList: (val) => del(`/api/${val}`), // 删除
    test: (val, id, config) => post(`/test/${id}`, val, config), // 添加
    access: (val) => put('/ip-access-policy/grant/api', val), // 绑定访问策略
    flow: (val) => patch('/api/flow-control', val), // 绑定流量控制
    release: (val) => patch('/api/env', val), // 发布api
    offline: (val) => del('/api/env', val), // 下线api
    getGroups: (val) => get('/api/groups', val), // 获得分组集合
    impSwagger: (val) => post('/api/swagger-import', val), // swagger导入
    checkSwagger: (val) => post('/api/swagger-json-check', val) // swagger json格式检验
}